<template>
  <StaticDataTable class="static-table-list stock-pricing-matrix-table">
    <template v-slot:header>
      <tr>
        <th> </th>
        <th v-for="(headerTitle, index) in headerColumnList" :key="index">{{headerTitle}}</th>
      </tr>
    </template>
    <template v-slot:body>
      <tr v-for="(matrixRow, index) in rowList" :key="index">
        <td class="font-weight-bold">{{matrixRow.name}}</td>
        <td v-for="(matrixCell, cellIndex) in matrixRow.dataList" :key="cellIndex">
          <span 
            v-show="matrixCell != null"
            :class="[matrixRow.percentAdjust < 0 ? 'financial-loss' : (matrixRow.percentAdjust > 0 ? 'financial-profit' : '')]">
            {{priceMatrixValue(matrixCell)}}
          </span>
        </td>
      </tr>
    </template>
  </StaticDataTable>
</template>


<script>
import StaticDataTable from "@/components/table/staticDataTable.vue"
import Utils from '@/utils/utils'
import currency from 'currency.js'

export default {
  name: "StockPricingMatrix",
  components: {
    StaticDataTable
  },
  props: {
    priceCategoryList: Array,
    displayPrice: {
      type: Boolean,
      default: true
    },
    uomType: String
  },
  data: () => {
    return {
      loading: false,
      salesRateList: []
    }    
  },
  mounted() {
    this.requestSalesRateMatrixList()
  },
  computed: {
    headerColumnList() {
      if(!this.priceCategoryList)
        return []

      return this.priceCategoryList.filter(priceCat => {
        // Only show if used by the data
        if(!priceCat || !priceCat.isActive)
          return false
        return true
      }).map(priceCat => {
        return priceCat.name
      })
    },
    rowList() {
      if(!this.salesRateList || !this.priceCategoryList)
        return []

      return this.salesRateList.filter(priceMatrixRow => {
        if(!priceMatrixRow.isActive)
          return false
        return true
      }).map(priceMatrixRow => {

        var dataList = this.priceCategoryList.filter(priceCat => {
          if(!priceCat || !priceCat.isActive)
            return false
          return true
        }).map(priceCat => {
          var originalPrice = parseFloat(priceCat.price)
          var adjustedPrice = Utils.roundCurrency(currency(originalPrice).multiply(priceMatrixRow.percentAdjust).multiply(0.01).add(originalPrice).value)

          var value = 0
          if(this.$props.displayPrice)
            value = adjustedPrice
          else
            value = adjustedPrice - originalPrice

          return value.toFixed(2)
        })

        return {
          name: priceMatrixRow.name,
          percentAdjust: priceMatrixRow.percentAdjust,
          dataList: dataList
        }
      })
    }
  },
  methods: {
    requestSalesRateMatrixList() {
      this.loading = true

      this.$apiService.pricingService.getSalesRateList()
      .then(response => {
        this.$data.salesRateList = response.data
      })
      .finally(() => {
        this.loading = false
      })
    },
    priceMatrixValue(value) {
      if(this.displayPrice)
        return this.$options.filters.formatPriceWithUOM(value, this.uomType)
      else {
        var display = this.$options.filters.formatPriceWithUOM(value, this.uomType)
        if(value > 0)
          display = "+" + display
        return display
      }
    }
  }
}
</script>
